import { useMemo, useState } from "react";
import SearchStockList from "./SearchStockList";
import VehicleShowroomWorksForm from "../VehicleShowroomWorksForm";
import StepTimeline from "./StepTimeline";
import { useNavigate } from "react-router-dom";
import { customerAttachmentParser } from "../../../utils/stockList.utils";

export default function VehicleShowroomWorksStep({
  title,
  editItem,
  existVehicle,
  redirectTo,
  addWorks
}) {
  const navigate = useNavigate();
  const editFormattedItem = customerAttachmentParser(editItem);
  const attachement = editFormattedItem?.attachment;

  // is exist vehicle ? that means add from already have vehicle information through route state
  const isExistVehicle = !!existVehicle?.id;

  const vehicle = attachement?.car ? attachement?.car : isExistVehicle ? existVehicle : null;

  const [step, setStep] = useState({
    car: vehicle,
    assigned_person: attachement?.assigned_person ? attachement?.assigned_person : null,
    currentStep: editFormattedItem?.id ? 2 : isExistVehicle ? 2 : 1,
    carSearch: attachement?.car?.chassis ?? existVehicle?.fullChassis ?? "",
    addWorks: attachement?.works ?? addWorks ?? ""
  });

  const onBack = () => {
    if (isExistVehicle || !!editItem?.id) {
      navigate(redirectTo);
    } else {
      setStep((prev) => ({ ...prev, currentStep: 1 }));
    }
  };

  const car = step?.car ?? null;
  const assigned_person = step?.assigned_person ?? null;

  let defaultValues = useMemo(() => {
    return {
      car: {
        stock_list_id: car?.id ?? car?.stock_list_id ?? "",
        sku: car?.sku ?? "",
        name: car?.name ?? "",
        chassis: car?.fullChassis ?? car?.chassis ?? "",
        engine: car?.engine ?? "",
        year: car?.year ?? "",
        color: car?.color ?? "",
        cc: car?.cc ?? "",
        fuel: car?.fuel ?? "",
        tyre_size: car?.tyre_size ?? "",
        mileage: car?.mileage ?? ""
      },
      assigned_person: {
        name: assigned_person?.name ?? "",
        assigned_date: assigned_person?.assigned_date ?? "",
        deadline: assigned_person?.deadline ?? ""
      },
      works: step?.addWorks ?? "",
      showroomWorkDate: editFormattedItem?.showroomWorkDate
        ? editFormattedItem.showroomWorkDate
        : new Date(),
      id: editFormattedItem?.id ? editFormattedItem.id : ""
    };
  }, [car, editFormattedItem, assigned_person, step]);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 mx-auto">
          <StepTimeline step={step} />
          {step.currentStep === 1 && (
            <SearchStockList step={step} setStep={setStep} onBack={onBack} />
          )}
        </div>

        {step.currentStep === 2 && (
          <VehicleShowroomWorksForm
            existVehicle={existVehicle}
            title={title}
            defaultValues={defaultValues}
            onBack={onBack}
            redirectTo={redirectTo}
          />
        )}
      </div>
    </>
  );
}
